import { t } from 'ttag';

import Modal, { ModalProps } from '@ui/Modal';
import { Button } from '@ui/Button';
import Title from '@ui/Title';
import { memberReviewRequests } from '@urls';
import { useStaticFlags } from '@hook/useStaticFlags';
import HappyGirlIcon from '@svg/happy-girl.svg';

// style
import s from './MarkSoldSuccessModal.sss';

type MarkSoldSuccessModalProps = ModalProps;

export const MarkSoldSuccessModal: React.FC<MarkSoldSuccessModalProps> = ({
  isOpen,
  onRequestClose,
}) => {
  const staticFlags = useStaticFlags();
  if (!staticFlags) {
    return null;
  }

  return (
    (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
      >
        <HappyGirlIcon className={s.icon} />
        <div className={s.text}>
          <Title
            type="h3"
            bold={false}
            className={s.title}
          >
            { staticFlags.commissionEnable ? t`Ми отримали оплату, дякуємо ❤` : t`Дякуємо ❤`}
          </Title>
          <p>{t`Раді, що ваша річ знайшла нового власника!`}</p>
          <p>{t`Саме час залишити відгук покупцю 😉`}</p>
        </div>
        <div className={s.buttons}>
          <Button
            theme="secondary"
            className={s.actionButton}
            onClick={onRequestClose}
          >
            {t`Іншим разом`}
          </Button>
          <Button
            className={s.actionButton}
            onClick={() => window.location.href = memberReviewRequests}
          >
            {t`Залишити відгук`}
          </Button>
        </div>
      </Modal>
    )
  );
};

export default MarkSoldSuccessModal;
